// src/components/public/AuthShell.js
// The card every sign-in / recovery page sits in: photo background, logo, heading, footer. Styles: pages/auth.css
import React from "react";
import { Link } from "react-router-dom";
import { FiAlertCircle, FiCheck } from "react-icons/fi";

import "../../pages/cx.css"; // theme tokens (--accent ...)
import "../../pages/auth.css";

/**
 * @param {string} title
 * @param {string} [subtitle]
 * @param {"success"|"error"} [status]  shows a round icon above the title
 */
export default function AuthShell({ title, subtitle, status, children }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <header className="auth-brand">
          {status ? (
            <span className={`auth-status is-${status}`} aria-hidden="true">
              {status === "success" ? <FiCheck /> : <FiAlertCircle />}
            </span>
          ) : (
            <Link to="/" aria-label="Nnetego home">
              <img src="/images/logo.png" alt="Nnetego" />
            </Link>
          )}
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </header>

        {children}

        <footer className="auth-foot">
          © {new Date().getFullYear()} Nnetego. All rights reserved. <Link to="/legal/privacy">Privacy</Link> · <Link to="/legal/terms">Terms</Link>
        </footer>
      </div>
    </div>
  );
}
